import { FeatureFlag } from 'common/types/growthbook';

export const EU_SPEC_INFO: FeatureFlag = {
  key: 'eu-special-info_mwp',
  defaultValue: false,
};

export const US_LEGAL_ADDRESS: FeatureFlag = {
  key: 'us_legal_address_mwp',
  defaultValue: false,
};

export const EU_UK_UAE_MU_LEGAL_ADDRESS: FeatureFlag = {
  key: 'eu_uk_uae_mu_legal_address_mwp',
  defaultValue: false,
};

export const FLOWS_AB_TEST: Record<any, any> = {};
